import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Card from '../../../../core/layout/Card';
import InstructionListContainer from './CanDoListContainer';
import Button from '../../../../core/form/Button';
import InstructionFormContainer from './CanDoFormContainer';

export default class CanDoScene extends React.Component {
  static propTypes = {
    courseId: PropTypes.string.isRequired,
  };

  state = { currentState: 'LIST', currentInstruction: null };

  handleChangeToForm = (instruction) => {
    this.setState({
      currentState: 'FORM',
      currentInstruction: get(instruction, 'id', null),
    });
  };

  handleChangeToList = () => {
    this.setState({
      currentState: 'LIST',
      currentInstruction: null,
    });
  };

  render() {
    if (this.state.currentState === 'LIST') {
      return (
        <Card
          title="Instructions"
          actions={<Button type="primary" label="New can do" icon="plus" onClick={this.handleChangeToForm} />}
        >
          <InstructionListContainer onEdit={this.handleChangeToForm} courseId={this.props.courseId} />
        </Card>
      );
    }
    if (this.state.currentState === 'FORM') {
      return (
        <Card
          title={this.state.currentInstruction ? 'Edit Can do' : 'New Can do'}
          actions={<Button icon="arrow-left" label="Back" type="default" onClick={this.handleChangeToList} />}
        >
          <InstructionFormContainer
            courseId={this.props.courseId}
            instructionId={this.state.currentInstruction}
            onSuccess={this.handleChangeToList}
          />
        </Card>
      );
    }
    return null;
  }
}
